<template>
  <section class="section">
    <header class="mod-title-lv1">
      <div class="inner">
        <h2>面接内容・質問ポイント</h2>
        <p class="lead">
          ××職の面接内容・質問ポイント情報です。
        </p>
      </div>
    </header>
    <section class="mod-job-content">
      <h3 class="mod-title-lv2">
        一次面接の面接官について
      </h3>
      <div class="mod-job-info">
        <dl
          v-for="(interviewer, i) in interviewCountermeasure.interviewers"
          :key="i"
        >
          <dt
            style="height: 97px;"
            :data-test="`interviewer-${i}`"
          >
            {{ i + 1 | formatNumber }}人目
          </dt>
          <dd style="height: 97px;">
            <p :data-test="`interviewer-${i}-gender`">
              性別:<span>{{ interviewer.interviewerGender.name }}</span>
            </p>
            <p :data-test="`interviewer-${i}-position`">
              役職:<span>{{ interviewer.interviewerPosition.name }}</span>
            </p>
            <p :data-test="`interviewer-${i}-generation`">
              年齢:<span>{{ interviewer.interviewerGeneration.name }}</span>
            </p>
          </dd>
        </dl>
        <dl
          v-if="interviewCountermeasure.interviewerNote"
          data-test="interview-note-container"
        >
          <dt>
            備考
          </dt>
          <dd>
            <p data-test="interview-note">
              {{ interviewCountermeasure.interviewerNote }}
            </p>
          </dd>
        </dl>
      </div>
      <div class="mod-job-qa">
        <section class="item">
          <h4 class="mod-title-lv2 title green">
            一次面接の<br>質問内容・流れ
          </h4>
          <div class="body">
            <template v-for="(interviewInformationFlow, i) in interviewCountermeasure.interviewInformationFlows">
              <p
                v-if="interviewInformationFlow.interviewProcess.url"
                :key="`has-url-${i}`"
              >
                <a
                  :href="`${userEndPoint + interviewInformationFlow.interviewProcess.url}`"
                  rel="nofollow"
                  target="blank"
                  :data-test="`interview-process-url-${i}`"
                >{{ interviewInformationFlow.interviewProcess.name }}</a>
              </p>
              <p
                v-else
                :key="`free-${i}`"
                :data-test="`interview-process-${i}`"
              >
                {{ interviewInformationFlow.freeComment }}
              </p>
              <span
                v-if="i < interviewCountermeasure.interviewInformationFlows.length - 1"
                :key="`next-icon-${i}`"
                :data-test="`next-icon-${i}`"
              >↓</span>
            </template>
            <p class="mt10">
              <span class="mod-icon required">ポイント</span>
              各項目をクリックすると、質問に対する対策を読むことが出来ます。
            </p>
            <p class="ml60">
              <a
                :href="`${userEndPoint}/tensyoku-knowhow/technique/interview/`"
                data-test="point-answer-manual"
                target="blank"
              >質問内容に対する対策一覧を読む</a>
            </p>
            <p><span class="color-strong">※上記「質問内容・流れ」は一例になります。異なる場合があることを、あらかじめご了承ください。</span></p>
          </div>
        </section>
        <section class="item">
          <h4 class="mod-title-lv2 title light-green">
            求める能力、<br>重視するポイント
          </h4>
          <div class="body">
            <div class="category">
              <p class="pull-left">
                実務能力
              </p>
              <ol class="stars environment">
                <li
                  v-for="count in starCount"
                  :key="count"
                >
                  <img
                    :data-test="`skill-star-${count}`"
                    :src="`${userEndPoint}/common/img/module/${starIconFileName(count,interviewCountermeasure.skillAchievementId)}`"
                  >
                </li>
              </ol>
            </div>
            <div class="category">
              <p class="pull-left">
                ビジネスマナー
              </p>
              <ol class="stars environment">
                <li
                  v-for="count in starCount"
                  :key="count"
                >
                  <img
                    :data-test="`business-star-${count}`"
                    :src="`${userEndPoint}/common/img/module/${starIconFileName(count, interviewCountermeasure.businessMannerId)}`"
                  >
                </li>
              </ol>
            </div>
            <div class="category">
              <p class="pull-left">
                コミュニケーション能力･論理的思考力
              </p>
              <ol class="stars environment">
                <li
                  v-for="count in starCount"
                  :key="count"
                >
                  <img
                    :data-test="`communication-star-${count}`"
                    :src="`${userEndPoint}/common/img/module/${starIconFileName(count, interviewCountermeasure.communicationAbilityId)}`"
                  >
                </li>
              </ol>
            </div>
            <div class="category">
              <p class="pull-left">
                仕事への意欲、エネルギー
              </p>
              <ol class="stars environment">
                <li
                  v-for="count in starCount"
                  :key="count"
                >
                  <img
                    :data-test="`work-star-${count}`"
                    :src="`${userEndPoint}/common/img/module/${starIconFileName(count,interviewCountermeasure.volitionId)}`"
                  >
                </li>
              </ol>
            </div>
            <div class="category">
              <p class="pull-left">
                社風とのマッチ度
              </p>
              <ol class="stars environment">
                <li
                  v-for="count in starCount"
                  :key="count"
                >
                  <img
                    :data-test="`matching-star-${count}`"
                    :src="`${userEndPoint}/common/img/module/${starIconFileName(count,interviewCountermeasure.matchingId)}`"
                  >
                </li>
              </ol>
            </div>
          </div>
        </section>
      </div>
    </section>
    <section
      v-for="(checkPointCategory, index) in checkPointCategories"
      :key="index"
      data-test="checkpoint-container"
      class="mod-job-content"
    >
      <h3
        class="mod-title-lv2"
        :data-test="`check-point-category-name-${index}`"
      >
        {{ checkPointCategory.name }}
      </h3>
      <div class="mod-job-qa">
        <section
          v-for="(checkpointDetail, i) in checkPointCategory.checkpointDetails"
          :key="i"
          class="item"
        >
          <p
            class="subject mb10 size-large"
            :data-test="`checkpoint-title-${index}-${i}`"
          >
            {{ checkpointDetail.summary }}
          </p>
          <p :data-test="`checkpoint-content-${index}-${i}`">
            {{ checkpointDetail.contents }}
          </p>
        </section>
      </div>
    </section>
    <section
      v-if="interviewCountermeasure.advice"
      class="mod-job-content"
      data-test="advice-container"
    >
      <h3 class="mod-title-lv2">
        活躍中社員からの面接アドバイス
      </h3>
      <div class="mod-job-qa">
        <section class="item">
          <p data-test="advice">
            {{ interviewCountermeasure.advice }}
          </p>
        </section>
      </div>
    </section>
  </section>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/base" as *;
</style>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  filters: {
    // 1〜３を漢字に変換
    formatNumber (number) {
      switch (number) {
        case 1 :
          return '一'
        case 2 :
          return '二'
        case 3 :
          return '三'
      }
    }
  },
  props: {
    interviewCountermeasure: {
      type: Object,
      required: true
    },
    userEndPoint: {
      type: String,
      required: true
    }
  },
  computed: {
    starCount: () => 5,
    ...mapGetters({
      interviewCheckpointCategories: 'interviewCheckpointCategoriesMaster'
    }),
    checkPointCategories () {
      return _.get(this.interviewCountermeasure, 'interviewInformationCheckpoints', []).map(interviewInformationCheckpoint =>
        ({
          name: this.interviewCheckpointCategories.find(interviewCheckpointCategory => interviewCheckpointCategory.id === interviewInformationCheckpoint.checkpointCategoryId)?.name,
          checkpointDetails: interviewInformationCheckpoint.checkpointDetails
        })
      )
    }
  },
  methods: {
    starIconFileName (count, enableStarCount) {
      return count <= enableStarCount ? 'matching_star_icon03.png' : 'matching_star_icon06.png'
    }
  }
}
</script>
